import { render, staticRenderFns } from "./MushroomTypeList.vue?vue&type=template&id=32d19a6c&scoped=true&"
import script from "./MushroomTypeList.vue?vue&type=script&lang=js&"
export * from "./MushroomTypeList.vue?vue&type=script&lang=js&"
import style0 from "./MushroomTypeList.vue?vue&type=style&index=0&id=32d19a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d19a6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VDataTable,VIcon})
